import Axios from 'axios'
import Vue from 'vue'
import Store from '@/store/store'
import Qs from 'qs'
import Router from '@/router'
import Global from '@/utils/global'
import Env from '@/config/env.modal'
import GetSite from '@/config/api.modal'
//获取域名
const api_site = GetSite(Env);

//添加请求拦截器        跟这个 是同时进行的
Axios.interceptors.request.use(config => { //在发送请求之前执行方法
	if(config.method == "get") { //设置content-type;
		config.headers['Content-Type'] = "application/json; charset=utf-8";
		//如果是get请求，且params是数组类型如arr=[1,2]，则转换成arr=1&arr=2
		config.paramsSerializer = params => Qs.stringify(params, {
			arrayFormat: 'repeat'
		});
	}
	if(config.headers && !config.headers.noLoading) {
		Store.commit('UPDATALOADING', true) //显示loading
	}
	if(config.headers && config.headers.noCheckLogin) {
		Store.commit('UPDATAISCHECKLOGIN', false);
	}
	delete config.headers.noLoading

	config = formatConfig(config);
	return config
}, error => { //请求错误时执行方法
	return Promise.reject(error)
})

//添加响应拦截器
Axios.interceptors.response.use(response => { //响应数据执行方法
	successState(response);
	return response.data
}, error => {
	errorState(error.response)
	//return Promise.resolve(error.response)  //请求错误执行方法
});

/*二次封装axios*/
//错误执行方法
function errorState(res) {
	Store.commit('updataLoading', false) //隐藏loading
	// 如果http状态码正常，则直接返回数据
	if(res && res.status && (res.status == 200 || res.status == 304 || res.status == 400)) {
		//Vue.prototype.$Message.info(res.statusText);
		return res.data
		// 如果不需要除了data之外的数据，可以直接 return response.data
	} else if(res && res.status && res.data && res.status == 500) {
		Vue.prototype.$Message.error(res.data.msg);
		//Vue.prototype.$Message.info('请求失败');
	} else if(res && res.statusText) {
		Vue.prototype.$Message.error(res.statusText);
	}
}

//接口请求成功返回的方法
function successState(res) {
	Store.commit('UPDATALOADING', false) //隐藏loading
	if(res.data.isLogin != undefined && Store.state.isCheckLogin) {

	}
	if(res.data&&!res.data.success&&res.config.headers&&!res.config.headers.noShowError){
		let msg="";
		if(res.data&&res.data.msg){
      msg=res.data.msg;
      if (['请登录', '请先登录'].includes(msg)) {
        Router.push({
          path: '/Login'
        })
        return 
      }
		}
		Vue.prototype.$Message.error(msg);
	}

}
//格式化请求数据
function formatConfig(config) {
	if(['get', 'delete'].includes(config.method) && config.params) { //get请求
		Object.keys(config.params).forEach(k => {
			if(config.params[k] === "") {
				delete config.params[k]
			}
			config.params[k]=HandleSpecial(config.params[k]);
		});
		return config;
	}
	if(config.method == "put" || config.method == "post") { //put请求和delete请求post请求
		if(config.data && config.headers['Content-Type'] == "application/x-www-form-urlencoded") {
			config.data = getParamsData(config.data);
			return config;
		}
		if(config.data) {
			Object.keys(config.data).forEach(k => {
				if(config.data[k] === "" || config.data[k] === null) {
					delete config.data[k]
				} else {
					config.data[k] = HandleSpecial(config.data[k]);
				}
			});
		}
	}
	return config;
}
//删除value是空的项  这个
function getParamsData(_data) {
	let index = -1;
	let arr = [];
	let length = 0;
	let res = {};
	let _str = "";
	if(!_data) {
		return res;
	}
	arr = _data.split('&');
	length = arr.length;
	arr.forEach(t => {
		res[t.split('=')[0]] = t.split('=')[1];
	});
	Object.keys(res).forEach(k => {
		if((typeof(res[k]) == 'string')) {
			res[k] = HandleSpecial(res[k]);
		}
		if(res[k] !== "") {
			_str += ((_str ? "&" : "")) + k + "=" + res[k];
		}
	})
	res = _str;
	return res;
}
//特殊字符串处理,除去
function HandleSpecial(params) {
	if(params && (typeof(params) == 'string')) {
		params = fifterStr(params);
	}
	if(params && Array.isArray(params)) {
		params.forEach(t => {
			if(t) {
				t = HandleSpecial(t);
			}
		});
	}
	if(params && Object.prototype.toString.call(params) === '[Object Object]') {
		Object.keys(params).forEach(k => {
			if(params[k]) {
				params[k] = HandleSpecial(params[k]);
			}
		})
	}
	return params;
}
//去掉多余字符串
function fifterStr(str) {
	str = str.replace(/[\n\r\t]/g, "");
	str = str.replace(/(^\s*)|(\s*$)/g, "");
	return str
}


let unique_identity = localStorage.getItem("unique_identity");
if(!unique_identity) {
	unique_identity = Global.uuid();
	localStorage.setItem("unique_identity", unique_identity);
}
function getToken(){
	let token = localStorage.getItem("token") ? localStorage.getItem("token") : "";
	return token
}
//设置默认请求头
Axios.defaults.headers = {
	unique_identity: unique_identity,
	token: getToken(),
	'Content-Type': 'application/x-www-form-urlencoded'
}
Axios.defaults.baseURL = api_site.WEBSITE + "/api/v1";

export default Axios;



// WEBPACK FOOTER //
// ./src/utils/axios.js